import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosRequestHeaders, AxiosResponse } from 'axios';
import { v4 as uuidv4 } from 'uuid';
import config from '../config/config';
import { showErrorSnackbar } from './Snackbar';

const headers: AxiosRequestHeaders = {
  'Content-Type': 'application/json',
  'x-trace-id': uuidv4(),
};
const currentYear = new Date().getFullYear();
const currentMonth = new Date().getMonth();
const financialYear = currentMonth >= 3 ? currentYear : currentYear - 1;
export const currentFinancialYear = `${financialYear}-${financialYear + 1}`;

const CommHandler: AxiosInstance = axios.create({
  baseURL: config.apiBaseUrl,
  headers: {
    ...headers,
  },
});

const requestInterceptor = (request: AxiosRequestConfig) => {
  request.headers = request.headers || {};
  request.headers['x-idToken'] = localStorage.getItem('token') || '';
  request.headers['x-user_id'] = localStorage.getItem('user_id') || '';
  request.headers['x-department'] = localStorage.getItem('department') || '';
  request.headers.user = localStorage.getItem('user') || '';
  return request;
};
const responseSuccessInterceptor = (response: AxiosResponse) => {
  return Promise.resolve(response.data);
};

const responseErrorInterceptor = (err: AxiosError) => {
  if (err.response) {
    let errorMessage = 'Unknown Error';

    const response = err.response as { data?: { message?: string; status?: number; error?: string | [{ msg?: string }] }; statusText?: string };

    const isUserRoleApi = err.config?.url?.includes('/role/user-role');

    if (err.response?.status === 401) {
      window.location.href = '/';
      return Promise.reject(new Error('Unauthorized'));
    }

    // Handle different backend error response formats
    if (response.data?.error && typeof response.data.error === 'string') {
      // Handle case where error is a string (like foreign key constraint errors)
      const errorString = response.data.error;

      // Check for specific foreign key constraint error for form deletion
      if (errorString.includes('violates foreign key constraint "fk_form_id" on table "questioner_user"')) {
        errorMessage = 'User has already filled this form';
      } else {
        errorMessage = errorString;
      }
    } else if (typeof response?.data?.error === 'string' && response?.data?.error?.startsWith('The following titles already exist')) {
      errorMessage = response.data.error;
    } else if (response.data?.message) {
      // Handle case where message is provided
      errorMessage = response.data.message;
    } else if (response.data?.error && Array.isArray(response.data.error)) {
      // Handle case where error is an array (validation errors)
      errorMessage = response.data.error[0]?.msg || 'Validation error';
    } else {
      // Fallback to statusText
      errorMessage = err.response.statusText || 'Unknown Error';
    }

    const errorMessageCapitalized = errorMessage.charAt(0).toUpperCase() + errorMessage.slice(1);

    if (!isUserRoleApi && !errorMessage.startsWith('The following titles already exist:')) {
      showErrorSnackbar(errorMessageCapitalized);
    }

    return Promise.reject(new Error(errorMessageCapitalized));
  }
  const genericErrorMessage = 'Something went wrong';

  const isUserRoleApi = err.config?.url?.includes('/role/user-role');
  if (!isUserRoleApi) {
    showErrorSnackbar(genericErrorMessage);
  }

  return Promise.reject(new Error(genericErrorMessage));
};
export const getcurrentFinancialYear = () => {
  try {
    const year = new Date().getFullYear();
    const month = new Date().getMonth();
    const finYear = month >= 3 ? year : year - 1;
    const finYearString = `${finYear}-${finYear + 1}`;
    return finYearString.toString();
  } catch (error) {
    console.error('Error calculating current financial year:', error);
    return 'Unknown';
  }
};
CommHandler.interceptors.request.use(requestInterceptor);
CommHandler.interceptors.response.use(responseSuccessInterceptor, responseErrorInterceptor);

export default CommHandler;
